import React from "react";
import { Skeleton, Card, Typography, Button, List } from "antd";

const { Title, Text } = Typography;

const PlanCardSkeleton = () => (
  <div className="plan-card">
    <Title level={4} style={{ textAlign: "center" }}>
      <Skeleton.Input style={{ width: 120 }} active size="default" />
    </Title>

    <Text
      style={{
        display: "block",
        textAlign: "center",
        fontSize: "22px",
        fontWeight: 600,
        marginBottom: 10,
      }}
    >
      <Skeleton.Input style={{ width: 100 }} active size="default" />
    </Text>

    <List
      dataSource={Array.from({ length: 5 }).map((_, i) => i)}
      renderItem={() => (
        <List.Item style={{ padding: "4px 0", border: "none" }}>
          <Skeleton.Input style={{ width: "90%" }} active size="small" />
        </List.Item>
      )}
      style={{ margin: "15px 0" }}
    />

    <div style={{ textAlign: "center" }}>
      <Button
        disabled
        style={{ borderRadius: 10, padding: "10px 24px", minWidth: 150 }}
      >
        <Skeleton.Input style={{ width: 80 }} active size="default" />
      </Button>
    </div>
  </div>
);

const PlansSkeleton = () => {
  return (
    <div className="plans-container app-page">
      <h1>
        <Skeleton.Input
          style={{ width: 200, marginBottom: 40 }}
          active
          size="large"
        />
      </h1>
      <div className="plans-grid">
        <PlanCardSkeleton />
        <PlanCardSkeleton />
        <PlanCardSkeleton />
      </div>
    </div>
  );
};

export default PlansSkeleton;
